import i18n from '@/i18n';

export default {
  passwordRules:
    'Enter a password with eight characters, including at least one uppercase letter, one lowercase letter, and one number. (Not use passwords used previously)',
  establishmentCurrentAccount: `<b>${i18n.t('Attention')}:</b></br>${i18n.t(
    'Only current establishments are displayed'
  )}.`
};
